/**
 * What: Shopify "Tests" page merchant-facing copy for the "Running now" cards, test statuses and row details.
 * Transport / data-flow: Pure string dictionary segment merged by shopify-component-copy.ts for Shopify UI consumers.
 *
 * Copy contract: the page lists the latest run per test. Response progress, when shown, is completed and
 * planned responses counted across the versions included in that run — not every version of the test (a run can
 * cover only some versions), not unique shoppers, not per version, and
 * never a time estimate. Milestones come only from the server-confirmed run stage (`latestRun.stage`, #3983) and
 * use exactly the owner-approved labels below. Do not add copy that promises response timing or other stages.
 */
export const shopifyComponentTestsIndexCopy = {
    testsIndex: {
        retryAction: 'Try again',
        untitledTest: 'Untitled test',
        activeHeading: 'Running now',
        activeInfo: 'Tests that are queued or still collecting shopper responses.',
        activeInfoHow: 'When available, progress counts completed and planned shopper responses across the versions included in the current run. It does not count unique shoppers and does not estimate time remaining. Milestones show the step the test is on now.',
        leavePageNote: 'You can leave this page. Finished tests show as Complete in the list below.',
        progressUnavailable: "Response progress isn't available for this test yet.",
        progressResponses: '{completed} of {planned} responses collected across the versions in this run',
        progressAccessibilityLabel: 'Responses collected for {title}',
        stageWaiting: 'Waiting to start',
        stagePreparingShoppers: 'Preparing simulated shoppers',
        stageAsking: 'Asking simulated shoppers',
        stageScoring: 'Scoring answers',
        stageWritingReport: 'Writing the report',
        stageInProgressLabel: 'In progress',
        stageListLabel: 'Test milestones',
        statusDraft: 'Draft',
        statusPrepared: 'Prepared',
        statusPreparing: 'Preparing',
        statusQueued: 'Queued',
        statusRunning: 'Running',
        statusComplete: 'Complete',
        statusFailed: 'Failed',
        statusCancelled: 'Cancelled',
        statusSuperseded: 'Superseded',
        statusReportUnavailable: 'Report unavailable',
        statusUnknown: 'Status unavailable',
        statusDeleting: 'Deleting',
        viewProgressAction: 'View progress',
        savedTimeLabel: 'Saved {date}',
        createdTimeLabel: 'Created {date}',
        startedTimeLabel: 'Started {date}',
        queuedTimeLabel: 'Queued {date}',
        finishedTimeLabel: 'Finished {date}',
        readOnlyMissingDetails: 'This test is missing the details needed to open it.',
        readOnlyAuthoringUnavailable: "Editing isn't available right now.",
        readOnlyPreparing: 'This test is still being prepared.',
        readOnlyPrepareFailed: "TestFeed couldn't prepare this test.",
        readOnlyRunFailed: "This run didn't finish.",
        readOnlyCancelled: 'This run was cancelled.',
        readOnlySuperseded: 'A newer run replaced this one.',
        readOnlyReportUnavailable: "This test finished, but its report isn't available yet.",
        readOnlyStatusUnknown: "We couldn't confirm this test's status.",
        readOnlyDeleting: 'This test is being deleted.',
        readOnlyNotEditableHere: "This test can't be edited here.",
        statusIssueFailed: "We couldn't refresh this test's status. What you see may be out of date.",
        statusIssueInvalid: "We got an unexpected status for this test, so it can't be shown reliably.",
        resultHeading: 'Result',
        resultUnavailable: 'Result unavailable',
        draftsErrorTitle: "Your saved drafts didn't load",
        draftsErrorBody: 'Your other tests are still shown. Try again to load your drafts.',
    },
};
//# sourceMappingURL=tests-index.js.map